import React from 'react';
import styled from 'styled-components';
import { LoadingBar } from '../../ui/LoadingBar';
import { Copy, Em, Flexer, Spacer } from '../dashboard/elements/LayoutElements';
import { Colors } from './../../ui';
import { Sebastian } from './ui/Sebastian';

const Title = styled.div`
    color: ${Colors.primary};
    font-size: 2.75rem;
    font-weight: 500;
`;

export const EditorLoading: React.FC<{ message?: string, progress?: number }> = ({ message, progress }) =>
    <Flexer inset flex="column" center>
        <Flexer flex="row" center>
            <Sebastian stance="normal" size="8" />
            <Flexer padding="2 0 0 0">
                <Title>Loading...</Title>
            </Flexer>
        </Flexer>
        <Spacer />
        <Flexer margin="1 0 " width="18">
            <LoadingBar color={Colors.primary} progress={progress} />
        </Flexer>
        <Copy ><Em>{message}</Em></Copy>
    </Flexer>;
